import React,{useState,useEffect} from 'react'
import './Work.scss';
import {AiFillEye} from 'react-icons/ai';
import {motion} from 'framer-motion';
import {ApplicationWrap,MotionWrap} from "../../wrapper";
import {urlFor, integrate} from '../../integrate'

const Work = () => {
  const [activeFilter, setActiveFilter]= useState('All');
  const [animatedCard, setAnimatedCard] = useState({ y: 0, opacity:1});
  const [works, setWorks] = useState([]);
  const [filterWorks, setFilterWorks] = useState([]);

useEffect(() => {
    const query = '*[_type == "works"]';

    integrate.fetch(query)
    .then((data)=> {
    setWorks(data);
    setFilterWorks(data);
})
}, [ ])

  const handleWorkFilter = (item) => {
            setActiveFilter(item);
            setAnimatedCard({y:100, opacity:0});

            setTimeout(() => {
              setAnimatedCard([{y:0, opacity:1}]);

              if(item ==='All') {
                setFilterWorks(works);
              } else {
                setFilterWorks(works.filter((work)=> work.tags.includes(item)));
              }
            }, 600);
  }
  return (
    <>
        <h1 className="head-text">
            My <span>Portfolio</span>
    </h1>

    <div className="app__work-filter">
      {['HTML,CSS & JS Websites', 'React JS Applications','MERN Applications', 'WordPress Websites', 'Web3.0 Applications','All'].map((item,i)=> (
              <div   
                key={i}
                onClick={()=> handleWorkFilter(item)}
                className={`app__work-filter-item app__flex p-text ${activeFilter === item? 'item-active': ' '}`}
              >
                      {item}
              </div>
 ) )}
    </div>
    <motion.div
    animate={animatedCard}
    transition={{duration:0.5, delayChildren:0.5}}
    className="app__work-portfolio"
    >
      {filterWorks.map((item,i)=> (
        <div className="app__work-item app__flex" key={i}>
          <div className="app__work-img app__flex">
            
            <img src={urlFor(item.imgUrl)} alt={item.name} />

      <motion.div
        whileHover={{opacity:[0,1]}}
        transition={{duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5}}
        className="app__work-hover app__flex"
      >
       <a href={item.projectLink} target="_blank" rel='noreferrer'>
         <motion.div
                 whileInView={{scale:[0,1]}}
                 whileHover={{scale:[1,0.9]}}
                 transition={{duration: 0.25}}
                 className="app__flex"
         >
             <AiFillEye/>
         </motion.div>
       </a>
      </motion.div>
      </div>
      <div className="app__work-content app__flex">
        <h4 className="bold-text">{item.title}</h4>
        <p className="p-text" style={{marginTop: 10}}>{item.description}</p>
        <div className="app__work-tag app__flex">
          <p className="p-text">{item.tags[0]}</p>
        </div>
      </div>
        </div>
      ))}
    </motion.div>
    </>
  )
}

export default ApplicationWrap(MotionWrap(Work, 'app__works'), 'work', 'app__primarybg');